var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0019 5.69321H10.0115V0.914437H10.0019C8.65013 0.912645 7.31224 1.18654 6.06995 1.71939L7.94333 6.11665C8.59343 5.83652 9.29399 5.69239 10.0019 5.69321Z",
    fill: "#D61D46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06887 1.72055C4.90515 2.22064 3.84668 2.93655 2.9494 3.83055L6.32753 7.20864C6.7927 6.74706 7.34043 6.377 7.94226 6.11768L6.06887 1.72055Z",
    fill: "#E4345B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.785667 7.03473C0.278234 8.23485 0.01203 9.52322 0.00219727 10.8262H4.78202C4.7929 10.1458 4.93751 9.47421 5.20759 8.84968L0.785667 7.03473Z",
    fill: "#9753A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32752 7.20869L2.94939 3.8306C2.02726 4.74833 1.29236 5.83659 0.785645 7.03483L5.20757 8.84978C5.4729 8.2364 5.85303 7.67933 6.32752 7.20869Z",
    fill: "#8F4B9C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77983 10.9136C4.77983 10.8846 4.77983 10.8552 4.77983 10.8262H5.4626e-06C5.4626e-06 10.8552 5.4626e-06 10.8846 5.4626e-06 10.9136C-0.00137899 12.2344 0.260407 13.5422 0.770079 14.7607L5.19145 12.947C4.91877 12.3038 4.77876 11.6122 4.77983 10.9136Z",
    fill: "#3D56A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19255 12.947L0.771179 14.7608C1.31089 16.0479 2.11285 17.2085 3.12595 18.1685L6.50676 14.7876C5.94013 14.2769 5.49166 13.6488 5.19255 12.947Z",
    fill: "#4961AC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50618 14.7887L3.12537 18.1695C4.03253 19.0305 5.09271 19.7141 6.25126 20.1852L8.06886 15.7644C7.49448 15.5339 6.96542 15.2036 6.50618 14.7887Z",
    fill: "#52BFA4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06999 15.7633L6.25238 20.1841C7.44319 20.6671 8.71632 20.9147 10.0013 20.9133H10.011V16.134H10.0019C9.34016 16.1347 8.68443 16.0089 8.06999 15.7633Z",
    fill: "#66C4AE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.9136C20 10.8846 20 10.8552 20 10.8262H15.2196C15.2196 10.8552 15.2223 10.8846 15.2223 10.9136C15.2226 11.5636 15.1006 12.2079 14.8627 12.8128L19.2852 14.6283C19.7589 13.4472 20.0016 12.1862 20 10.9136Z",
    fill: "#B2D23D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8617 12.8129C14.6014 13.4769 14.208 14.0806 13.7057 14.587L17.0839 17.9678C18.0336 17.0143 18.7818 15.8795 19.2841 14.631L14.8617 12.8129Z",
    fill: "#A3CD39"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0104 20.9134C11.3499 20.9132 12.6756 20.6428 13.908 20.1181L12.0341 15.7209C11.3941 15.9929 10.7059 16.1334 10.0104 16.1341V20.9134Z",
    fill: "#60BA46"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0855 17.9651L13.7073 14.5843C13.2291 15.0673 12.6613 15.4525 12.0357 15.7182L13.9096 20.1154C15.0965 19.6093 16.1748 18.8793 17.0855 17.9651Z",
    fill: "#74BF44"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0104 0.914429V5.6932C10.7072 5.69391 11.3968 5.8351 12.0379 6.10813L13.8549 1.68781C12.6375 1.17738 11.3306 0.91442 10.0104 0.914429Z",
    fill: "#E46733"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8549 1.68784L12.0378 6.10815C12.738 6.40721 13.3646 6.85502 13.8742 7.42066L17.255 4.03995C16.297 3.02869 15.1391 2.22768 13.8549 1.68784Z",
    fill: "#D65327"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2551 4.03995L13.8743 7.42066C14.2894 7.88048 14.6198 8.41031 14.8499 8.98551L19.2723 7.17121C18.801 6.01081 18.1168 4.94882 17.2551 4.03995Z",
    fill: "#E3BD32"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8499 8.98553C15.084 9.57146 15.209 10.1954 15.2185 10.8263H19.9989C19.9889 9.57307 19.7424 8.33299 19.2723 7.17123L14.8499 8.98553Z",
    fill: "#D7B029"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.0a79d7104e6782a1cec39252111d137d.svg";
export { ForwardRef as ReactComponent };